import { FC, ReactNode, lazy } from 'react';
import { useSelector } from 'react-redux';
import { authenticationSelector, showWelcomePopupSelector } from '~/components/authentication/ducks/selectors';
import { WelcomeScreenPopUp } from '~/components/account/async';
import { selectShouldShowCrossMarketingConsent } from '~/components/account/ducks';
import { isBridgeAvailable } from '~/components/app-bridge/index';

const CrossMarketingConsentPopup = lazy(() => import('~/components/account/cross-marketing-consent-popup'));

interface RegulationsContainerSGAProps {
	children: ReactNode;
}

const RegulationsContainerSGA: FC<RegulationsContainerSGAProps> = ({ children }) => {
	const authenticated = useSelector(authenticationSelector);
	const showWelcomePopup = useSelector(showWelcomePopupSelector);
	const shouldShowCrossMarketingConsent = useSelector(selectShouldShowCrossMarketingConsent);

	const isInMobileApp = isBridgeAvailable();

	return (
		<>
			{authenticated && showWelcomePopup && !isInMobileApp && <WelcomeScreenPopUp timePopup={10} />}
			{authenticated && shouldShowCrossMarketingConsent && (
				<CrossMarketingConsentPopup shouldShowCrossMarketingConsent={shouldShowCrossMarketingConsent} />
			)}
			{children}
		</>
	);
};

export default RegulationsContainerSGA;
